import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from "react";

interface ViewMember {
  id: string;
  name: string;
  orgId: string;
}

interface MemberViewContextType {
  viewingMember: ViewMember | null;
  setViewingMember: (member: ViewMember) => void;
  clearViewingMember: () => void;
}

const MemberViewContext = createContext<MemberViewContextType>({
  viewingMember: null,
  setViewingMember: () => {},
  clearViewingMember: () => {},
});

export const useMemberView = () => useContext(MemberViewContext);

export const MemberViewProvider = ({ children }: { children: ReactNode }) => {
  const [viewingMember, setViewingMemberState] = useState<ViewMember | null>(null);

  const setViewingMember = useCallback((member: ViewMember) => {
    setViewingMemberState(member);
  }, []);

  const clearViewingMember = useCallback(() => {
    setViewingMemberState(null);
  }, []);

  const value = useMemo(
    () => ({ viewingMember, setViewingMember, clearViewingMember }),
    [viewingMember, setViewingMember, clearViewingMember],
  );

  return <MemberViewContext.Provider value={value}>{children}</MemberViewContext.Provider>;
};
